import type { LensDocument, LensState } from './types';

export const LENS_STATE_PARAM = 'lensState';

const clean = (state: LensState): LensState =>
  Object.fromEntries(
    Object.entries(state).filter(([, value]) => value !== undefined && (typeof value !== 'object' || Object.keys(value).length > 0)),
  ) as LensState;

export function readLensState(search: string = window.location.search): LensState {
  try {
    const raw = new URLSearchParams(search).get(LENS_STATE_PARAM);
    return raw ? clean(JSON.parse(raw)) : {};
  } catch {
    return {};
  }
}

export function writeLensState(state: LensState) {
  const url = new URL(window.location.href);
  const tidy = clean(state);
  if (Object.keys(tidy).length) url.searchParams.set(LENS_STATE_PARAM, JSON.stringify(tidy));
  else url.searchParams.delete(LENS_STATE_PARAM);
  window.history.replaceState(window.history.state, '', url);
}

export function toggled(list: Array<string> | undefined, member: string): Array<string> {
  return list?.includes(member) ? list.filter((entry) => entry !== member) : [...(list ?? []), member];
}

export function withEntry<T>(record: Record<string, T> | undefined, key: string, value: T | undefined): Record<string, T> {
  const next = { ...(record ?? {}) };
  if (value === undefined || (Array.isArray(value) && !value.length)) delete next[key];
  else next[key] = value;
  return next;
}

const TITLE_TOKEN = /\{\$([A-Za-z0-9_]+)\}/g;

export function switchesInTitles(document: LensDocument): Set<string> {
  return new Set([...JSON.stringify(document.page).matchAll(TITLE_TOKEN)].map((match) => match[1]));
}
